export default "__VITE_ASSET__D$j1tl9f__"